export const mapa = [
    [1,1,1,1,1],
    [1,0,0,0,1],
    [1,0,1,0,1],
    [1,0,0,0,1],
    [1,1,0,1,1],
];

export const mapa2 = [
    [1,1,1,0,0,0,0,1,1,1],
    [1,1,1,0,0,0,0,1,1,1],
    [1,1,1,0,0,0,0,1,1,1],
    [1,0,0,0,0,0,0,0,0,1],
    [1,0,0,0,0,0,0,0,0,1],
    [1,0,0,0,0,0,0,0,0,1],
    [1,0,0,0,1,1,0,0,0,1],
    [1,0,0,0,1,1,0,0,0,1],
    [1,0,0,0,0,0,0,0,0,1],
    [1,1,0,1,1,1,1,0,0,1],
];

export const mapaTest = [
    1,1,1,1,1,
    1,0,0,0,1,
    1,0,0,0,1,
    1,1,0,1,1
];
// const mapaTestProcesado = splitterArray(mapaTest,5);